import axios from 'axios';
import apiConfig from '~Configs/apiConfig';

export const contentManagementInstance = axios.create({
  baseURL: apiConfig.contentManagmentUrl,
  headers: {
    'Umb-Project-Alias': apiConfig.umbProjectAlias,
    'Api-Key': apiConfig.umbApiKey,
  },
});
